module.exports = __webpack_public_path__ + "static/media/Saruul-Erdene.67f415b9.JPEG";